import React from 'react';

import { BucketIcon }               from '../../components/aws';
import { fmtS3ConsoleLink }         from '../../components/utils/formatters';

import { 
  createStorageResourceColumnDefs, 
  useStyles,
}                                   from '../../components/storage';

import { UserContext }              from '../../components/user';

import Resources                    from '../Resources';

const handleGoToBucket = (bucket) => {
  window.open(fmtS3ConsoleLink(bucket),"_blank");
};

const generateResourceActions = (resource) => {
  const resourceActions=[];
  resourceActions.push({ 
    name: `Go to Bucket`,
    icon: BucketIcon,
    onClick: () => handleGoToBucket(resource.Bucket),
    external: true,
  });
  return resourceActions;
};

export default function LandingZones(props) {

  const classes = useStyles();
  const uctx = React.useContext(UserContext);
  const columnDefs = createStorageResourceColumnDefs(classes,uctx);

  return (
    <Resources 
      type='LandingZone'
      columnDefs={columnDefs}
      actions={generateResourceActions}
    />
  );
}

LandingZones.propTypes = {
};

LandingZones.defaultProps = {
};
